<template>
  <div class="cms-edit-container">
    <el-form :model="postForm" class="modal" label-width="100px">
      <el-form-item label="标题" prop="title">
        <el-input class="cms-title" v-model="postForm.title" />
      </el-form-item>
      <el-form-item class="label-line-height" label="上传封面" >
        <el-upload
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :data="dataObj"
          :action="qiniuUp"
          :accept="accept"
          class="upload-size"
          list-type="picture-card">
          <el-popover
            placement="top-start"
            trigger="hover">
            <div class="popover-content"><img :src="postForm.badge | ImageFormats" alt="img" style="width: 600px;height: 600px;object-fit: contain;"/></div>
            <img slot="reference" v-show="postForm.badge" :src="postForm.badge | ImageFormats" >
          </el-popover>
          <i v-show="!postForm.badge" class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过10Mb</div>
        </el-upload>
      </el-form-item>
      <el-form-item class="label-line-height" label="生成附件链接" >
        <el-upload
                :on-success="handleSuccessKey"
                :on-error="handleError"
                :before-upload="beforeAvatarUploadKey"
                :show-file-list="false"
                :data="dataKeyObj"
                :action="qiniuUp"
                class="upload-size">
          <el-button type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">上传文件建议不超过10Mb</div>
        </el-upload>
        <div v-if="keyUrl" class="attach-file">
          <el-input v-model="keyUrl" :readonly="true" style="max-width: 500px;"></el-input>
          <el-button name="copy" type="primary" size="small"
                     v-clipboard:copy="keyUrl"
                     v-clipboard:success="onCopy"
                     v-clipboard:error="onError">复制链接</el-button>
        </div>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <div>
          <tinymce :height="300" v-model="postForm.content"/>
        </div>
      </el-form-item>
      <el-form-item label="顺序(升序)" >
        <el-input
          v-model="postForm.seq"
          type="Number"
          placeholder="请输入整数(>0)"/>
      </el-form-item>
      <el-form-item label="状态" >
        <el-radio-group v-model="postForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="-1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { getSubject, updateContentSubject, createContentSubject } from '@/api/cms'
import { ConstConfig, ImageFormat, showMessage, varConfig} from "@/utils";
import {getQiniuUploadToken} from "@/api/site";

export default {
  name: 'CmsContentEdit',
  components: { Tinymce },
  data() {
    return {
      dataObj: { token: '' },
      dataKeyObj: { token: '', key: '' },
      keyUrl: '',
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      postForm: {
        id:null,
        title:null,
        content:null,
        badge:null,
        seq:1,
        status:0,
      },
      params: this.$route.params
    }
  },
  created() {
    const params = this.$route.params
    if (params.subjectId) {
      this.getSubject()
    }
    this.getQiniuToken()
  },
  watch: {
    $route() {
      const params = this.$route.params
      if (params.subjectId) {
        this.getSubject()
      }
    }
  },
  methods: {
    onSubmit() {
      if(this.postForm.id) {
        this.updateSubject()
      } else {
        this.createSubject()
      }
    },
    getSubject() {
      const params = this.$route.params
      getSubject({id: params.subjectId}).then(response => {
        this.postForm= response.data.subject
      })
    },
    createSubject() {
      const data = {
        title: this.postForm.title,
        content: this.postForm.content,
        status: this.postForm.status,
        seq: this.seq,
        forumId: this.params.forumId
      }
      createContentSubject(data).then(response => {
        if(!response) return
        const data = response.data
        if(data) {
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.$router.replace({
            path: `/cms/activity/details/${data.subject.id}/${this.params.forumId}`
          })
        }
      }, reject=>{
        this.isLoading = false
        this.$message.error('数据保存失败')
      })
    },
    handleSuccess(response) {
      this.postForm.badge = response.hash
    },
    handleSuccessKey(response) {
      this.keyUrl = ImageFormat.fileView(response.key)
    },
    handleError(file) {
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传头像图片大小不能超过 10MB!')
      }
      return isLt2M
    },
    beforeAvatarUploadKey(file) {
      this.dataKeyObj.key = file.name
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        showMessage('error', '上传文件大小不能超过 10MB!')
      }
      return isLt2M
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.dataObj.token = data.token
        this.dataKeyObj.token = data.token
      }).catch(err => {
        console.log(err, 'error', '七牛Token获取失败')
      })
    },
    updateSubject() {
      const params = this.$route.params
      const data = {
        id: params.subjectId,
        title: this.postForm.title,
        content: this.postForm.content,
        seq: this.postForm.seq,
        status: this.postForm.status,
        badge: this.postForm.badge
      }
      updateContentSubject(data).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
        }
      })
    },
    onCopy: function (e) {
      console.log('复制成功！')
      this.$message({
        message: '复制成功',
        type: 'success',
        showClose: true,
        duration: 1000
      })
    },
    onError: function (e) {
      console.log('复制失败！')
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 156)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  #app .cms-title input{
    max-width: 900px;
  }
  #app .attach-file input{
    max-width: 900px;
  }
  .cms-edit-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .attach-file {

    }
  }
</style>
